import { FormModal } from '~/shared/forms/FormModal';
import { attachInterventionToGoalOptions, getGoalsAndInterventionsByCertificationPeriodOptions, type FullOrderViewModel } from '@generated';
import Yup from '~/util/yup';
import { useSuspenseQuery } from '@tanstack/react-query';
import { SelectFormField } from '~/shared/forms/controls/fields/SelectFormField';
import { useGoalsAndnterventionsForOrder } from '../queries';

const validationSchema = Yup.object().shape({
	interventionId: Yup.string().label('Intervention').nullable().required('Intervention is required')
});

export function AttachInterventionFormModal({
	goalId,
	fullOrder,
	closeModal
}: {
	goalId: string;
	fullOrder: FullOrderViewModel;
	closeModal: () => void;
}) {
	const { data: goalsAndInterventions } = useSuspenseQuery(getGoalsAndInterventionsByCertificationPeriodOptions(fullOrder.certificationPeriodId));
	const { refetch } = useSuspenseQuery(useGoalsAndnterventionsForOrder(fullOrder.id));
	const goal = fullOrder.goals.find(goal => goal.id === goalId);
	if (!goal) {
		throw new Error('Goal not found');
	}

	const interventionOptions = [
		...goalsAndInterventions.interventions.filter(x => x.invariants.canBeAttachedToGoal && !goal.interventionIds.includes(x.id)),
		...fullOrder.interventions.filter(x => x.invariants.canBeAttachedToGoal && !goal.interventionIds.includes(x.id))
	].map(x => ({
		name: x.templatedDefinitionText ?? x.definitionText,
		id: x.id
	}));

	return (
		<FormModal
			title="Attach Intervention"
			closeModal={closeModal}
			initialValues={{
				goalId: goal.id,
				interventionId: null
			}}
			saveMutation={attachInterventionToGoalOptions}
			onSuccess={() => {
				refetch();
				closeModal();
			}}
			validationSchema={validationSchema}
		>
			<SelectFormField name="interventionId" options={interventionOptions} />
		</FormModal>
	);
}
